export class RegiaoOptions {
    canImportErp: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canImportErp;
    }
}
